// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602251103/js/" + chunkId + "." + {"44":"6375f3a3","225":"cba3b3c7","481":"a9f7d65b","486":"366d144e","770":"3d062b56"}[chunkId] + ".0.056165946780688536.chunk.js";
};